export default __webpack_public_path__ + "static/media/featured.5ad8063b.jpg";